import { useLanguage } from '@/context/language-context';
import { loadTranslations } from '@/lib/i18n';
import itTranslations from '@/translations/it.json';
import { useEffect, useState } from 'react';

export function useTranslations(): any {
  const { language } = useLanguage();
  const [translations, setTranslations] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    loadTranslations().then(setTranslations);
  }, []);

  if (!translations) return itTranslations;
  return translations[language];
}